import { HotmartRum } from '@hot-observability-js/react'
import {
  registerPlugins,
  type ModuleFederationRuntimePlugin
} from '@module-federation/enhanced/runtime'

import { Logger } from './logger'

function errorHandlePlugin(): ModuleFederationRuntimePlugin {
  return {
    name: 'error-handle-plugin',
    errorLoadRemote(args) {
      const errorMessage = ((args.error ?? {}) as { message?: string })?.message || 'Unknown error'

      HotmartRum.captureMessage(
        `[RUNTIME] Failed to load remote module "${args.id}": ${errorMessage}`
      )

      return args
    }
  }
}

function loadRemoteModulePlugin(): ModuleFederationRuntimePlugin {
  return {
    name: 'load-remote-module-plugin',
    onLoad(args) {
      Logger.info(`Remote module "${args.id}" loaded`)
    }
  }
}

registerPlugins([errorHandlePlugin(), loadRemoteModulePlugin()])
